<style lang="scss" scoped>
.invalid-feedback {
  display: block;
}

i.fas {
  display: inline-block;
  padding: 0.5em 0.8em;
  border: 1px solid #d4d6db;
  border-radius: 100%;
  margin-right: 0.5rem;
  cursor: pointer;

  &.fa-male {
    &.selected {
      color: $male;
      border-color: $male;
    }

    &:hover {
      box-shadow: 0px 0px 10px $male;
    }
  }

  &.fa-female {
    &.selected {
      border-color: $female;
      color: $female;
    }

    &:hover {
      box-shadow: 0px 0px 10px $female;
    }
  }
}
</style>
<template>
  <div>
    <i
      class="fas fa-male text-xl"
      :class="{ selected: isGender(0) }"
      @click="setGender(0)"
    ></i>
    <i
      class="fas fa-female text-xl"
      :class="{ selected: isGender(1) }"
      @click="setGender(1)"
    ></i>
  </div>
</template>
<script>
export default {
  data() {
    return {
      genders: [
        { label: "männlich", selected: false, value: 0 },
        { label: "weiblich", selected: false, value: 1 }
      ]
    };
  },
  props: {
    value: {
      required: true
    }
  },
  created() {
    this.value.forEach(element => {
      this.setGender(element);
    });
  },
  methods: {
    setGender(value) {
      if (!this.$store.getters["user/auth"]) {
        this.$store.dispatch("publicProfileModal/show", this.$modal);
        return;
      }

      this.genders[value].selected = !this.genders[value].selected;
      this.$emit("input", this.selection());
    },
    selection() {
      const selection = this.genders.reduce((accumulator, select) => {
        if (select.selected) {
          accumulator.push(select.value);
        }
        return accumulator;
      }, []);
      return selection;
    },
    isGender(value) {
      return this.genders[value].selected;
    }
  }
};
</script>
